import { getFormFieldAccessibilityTarget } from '../modules/FormErrors';

class FormLostPassword {
    constructor() {
        this.root = document.querySelector('[js-form-lost-password]');
        this.init();
    }

    init() {
        if (!this.root) return;

        this.form = this.root.querySelector('form');
        this.errorsContainer = this.root.querySelector('[js-form-errors]');
        this.emailField = this.form?.querySelector('[name="user_login"]');

        if (!this.form || !this.errorsContainer || !this.emailField) return;

        this.hideFieldErrorRegions();
        this.syncServerErrors();
        this.events();
    }

    hideFieldErrorRegions() {
        this.root.querySelectorAll('[js-form-error]').forEach(region => {
            region.hidden = true;
        });
    }

    syncServerErrors() {
        const notices = document.querySelectorAll(
            '.woocommerce-error, .woocommerce-notices-wrapper .woocommerce-error'
        );

        notices.forEach(notice => {
            const items = notice.querySelectorAll('li');

            if (items.length) {
                items.forEach(item => {
                    const message = item.textContent.trim();
                    if (message) {
                        this.appendError(message, 'user_login');
                    }
                });
            } else {
                const message = notice.textContent.trim();
                if (message) {
                    this.appendError(message, 'user_login');
                }
            }

            const wrapper = notice.closest('.woocommerce-notices-wrapper');
            notice.remove();
            if (wrapper && !wrapper.children.length) {
                wrapper.remove();
            }
        });

        if (this.errorsContainer.children.length) {
            this.markFieldError(this.emailField);
        }
    }

    events() {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.emailField.addEventListener('input', () => {
            if (this.errorsContainer.children.length) {
                this.clearErrors();
            }
        });
    }

    clearErrors() {
        this.errorsContainer.innerHTML = '';
        const parent = this.emailField.closest('.group');
        const a11yTarget = getFormFieldAccessibilityTarget(this.emailField);
        parent?.classList.remove('-error');
        a11yTarget?.removeAttribute('aria-invalid');
    }

    appendError(message, fieldName = '') {
        if (!message) return;

        const existing = fieldName
            ? this.errorsContainer.querySelector(
                  `[data-error-for="${CSS.escape(fieldName)}"]`
              )
            : null;

        if (existing) {
            const text = existing.querySelector('p');
            if (text) {
                text.textContent = message;
            }
            return;
        }

        const row = document.createElement('div');
        row.className =
            'flex items-center gap-4 text-system-error-dark outline-none shadow-none';
        row.setAttribute('role', 'alert');
        row.setAttribute('tabindex', '-1');
        if (fieldName) {
            row.dataset.errorFor = fieldName;
        }
        row.innerHTML =
            '<i class="icon icon-input_error_new text-[12px]!" aria-hidden="true"></i><p class="text-tiny"></p>';
        row.querySelector('p').textContent = message;
        this.errorsContainer.appendChild(row);
    }

    markFieldError(field) {
        if (!field) return;
        const parent = field.closest('.group');
        const a11yTarget = getFormFieldAccessibilityTarget(field);
        parent?.classList.add('-error');
        a11yTarget?.setAttribute('aria-invalid', 'true');
    }

    onSubmit(e) {
        const value = (this.emailField.value || '').trim();
        this.emailField.value = value;

        // Blokuj tylko puste pole — format i istnienie konta sprawdza WooCommerce.
        if (value) {
            return;
        }

        e.preventDefault();
        this.clearErrors();
        this.markFieldError(this.emailField);
        this.appendError(
            window.phrases?.validation?.empty || 'Pole nie może być puste',
            'user_login'
        );
    }
}

new FormLostPassword();
